import React from 'react';
import { ThumbsUp, ThumbsDown } from 'lucide-react';
import { Theme } from '../types/theme';
import AudioControls from './AudioControls';

type AudioState = 'idle' | 'loading' | 'playing';

interface AudioControlProps {
    theme: Theme;
    textToSpeak?: string;
    onAudioAction?: (
        action: 'start' | 'stop',
        callbacks?: {
            onPlayStart: () => void;
            onEnd: () => void;
        }
    ) => void;
    externalState?: AudioState;
}

interface MessageActionsProps {
    theme: Theme;
    audioProps: AudioControlProps;
    onLike: () => void;
    onDislike: () => void;
    feedbackStatus?: 'none' | 'liked' | 'disliked';
}

const MessageActions: React.FC<MessageActionsProps> = ({
    theme,
    audioProps,
    onLike,
    onDislike,
    feedbackStatus = 'none',
}) => {
    const buttonStyle = {
        color: theme.textSecondaryColor,
        backgroundColor: `${theme.surfaceColor}80`,
    };

    return (
        <div className="flex items-center space-x-2">
            <AudioControls {...audioProps} />

            <div className="h-4 w-px bg-gray-300 dark:bg-gray-700 mx-1 opacity-50" />

            <button
                onClick={onLike}
                className={`p-1 rounded-lg transition-all duration-200 hover:opacity-80 ${feedbackStatus === 'liked' ? 'opacity-100' : 'opacity-60'
                    }`}
                style={{
                    ...buttonStyle,
                    color: feedbackStatus === 'liked' ? theme.primaryColor : theme.textSecondaryColor
                }}
                title="Good response"
            >
                <ThumbsUp
                    className="w-4 h-4"
                    fill={feedbackStatus === 'liked' ? 'currentColor' : 'none'}
                />
            </button>

            <button
                onClick={onDislike}
                className={`p-1 rounded-lg transition-all duration-200 hover:opacity-80 ${feedbackStatus === 'disliked' ? 'opacity-100' : 'opacity-60'
                    }`}
                style={{
                    ...buttonStyle,
                    color: feedbackStatus === 'disliked' ? '#ef4444' : theme.textSecondaryColor
                }}
                title="Bad response"
            >
                <ThumbsDown
                    className="w-4 h-4"
                    fill={feedbackStatus === 'disliked' ? 'currentColor' : 'none'}
                />
            </button>
        </div>
    );
};

export default MessageActions;
